<template>
  <el-scrollbar wrap-class='scrollbar-wrapper'>
 
    <el-menu
      ref='elmenu'
      :show-timeout='200'
      :default-active='$route.path'
      :collapse='isCollapse'
      mode='vertical'
      background-color='#304156'
      text-color='#BFCBD9' 
      active-text-color='#409EFF'
      :unique-opened='true'
    > 
      <sidebar-item v-for='route in menus' :key='route.path' :item='route' :base-path='route.path' />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { 
    SidebarItem 
  },
  data() {
    return {
      open: ['/base', '/lift', '/door', '', '/talkback', '/visitor', '/work', '/visitor'],
      menus: this.$router.options.routes
    }
  }, 
  mounted() {  
     this.$refs.elmenu.openedMenus.push(this.open[this.cursystem])
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'userRemoteMenuIds'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }, 
    cursystem() {
        return this.$store.getters.cursystem
    }, 
  },
  watch: {
      cursystem(val) {
        this.$refs.elmenu.openedMenus.push(this.open[val])   
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue